import {z} from "zod";
import {msObject} from "../resource-base/msObject";
import {IdSchema} from "../resource-base/baseSchemas";
import {VCycleSide, VCycleSideSchema} from "../enumerations/VCycleSide";
import {VCycleElementType, VCycleElementTypeSchema} from "../enumerations/VCycleElementType";
import {IntSchema} from "../../../../react-commons/schemas/integerSchemas";

export const StructuredVCycleElementOutlineSchema: z.ZodType<{
    id: string;
    type: VCycleElementType;
    displayName: string;
    referencedId: string;
    referencedObjectId: string;
    verticalPriority: number;
    horizontalPriority: number;
    textColor: string|null;
    backgroundColor: string|null;
    description: string;
    affectsRows: Array<number>;
}> = msObject({
    id: IdSchema,
    type: VCycleElementTypeSchema,
    displayName: z.string(),
    referencedId: IdSchema,
    referencedObjectId: IdSchema,
    verticalPriority: IntSchema,
    horizontalPriority: IntSchema,
    textColor: z.string().nullable(),
    backgroundColor: z.string().nullable(),
    description: z.string(),
    affectsRows: z.number().array()
});

export type StructuredVCycleElementOutline = z.infer<typeof StructuredVCycleElementOutlineSchema>;

export const StructuredVCycleContainerOutlineSchema: z.ZodType<{
    id: string;
    side: VCycleSide;
    index: number;
    type: VCycleElementType;
    embeddedDepth: number;
    column: number;
    rowSpan: number;
    elements: Array<StructuredVCycleElementOutline>,
    affectsRows: Array<number>;
}> = msObject({
    id: IdSchema,
    side: VCycleSideSchema,
    index: IntSchema,
    type: VCycleElementTypeSchema,
    embeddedDepth: IntSchema,
    column: IntSchema,
    rowSpan: IntSchema,
    elements: StructuredVCycleElementOutlineSchema.array(),
    affectsRows: z.number().array()
});

export type StructuredVCycleContainerOutline = z.infer<typeof StructuredVCycleContainerOutlineSchema>;


export const StructuredVCycleObjectOutlineSchema: z.ZodType<{
    maxNumberOfRows: number;
    maxNumberOfColumns: number;
    containers: Array<StructuredVCycleContainerOutline>
}> = msObject({
    maxNumberOfRows: IntSchema,
    maxNumberOfColumns: IntSchema,
    containers: StructuredVCycleContainerOutlineSchema.array()
});

export type StructuredVCycleObjectOutline = z.infer<typeof StructuredVCycleObjectOutlineSchema>;
